import React from "react";
import { Row, Col } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import InflationForm from "./InflationForm";

export default function Search(props) {
  let platformNames = ["Google", "Microsoft"];

  let thumbnail = require("images/ShowMeHow.jpg");
  thumbnail = <img className="thumbnail" src={`/datapulse${thumbnail}`} />;


  return (
    <div style={{ backgroundColor: "#F5F5F5" }}>
      <Row className="p-4">
        <Col>
          <div className="py-4">
            <span className="text-info visby-bold f-18">Inflation (Past 30 Days)</span>
            <span style={{cursor:"pointer"}}>
						<CustomTooltip inline={true} delay={1700} faClass="pl-2 text-info far fa-question-circle"  message={<a href={"https://www.youtube.com/watch?v=B_BFhFnahjw"} target="_blank">{thumbnail}</a>} />
						</span>
            <div className="py-4">
              <InflationForm inflation={props.inflation} setInflation={props.setInflation} platforms={platformNames} section={"search"} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
